export const handleError = error => {
  console.log(">> Loading scenarios failed" + error);
}